import React from "react";
import { useStore } from "../store/Store";

function Complete() {
  const store = useStore();

  // const getTheDate = (timeStamp) => {
  //   const dateFormat = new Date(timeStamp);
  //   return dateFormat.toDateString();
  // };
  // console.log(
  //   "final",
  //   store.articleNote.length ? store.articleNote[0].note : "fucker"
  // );

  function findArticleNote(i) {
    const myNote = store.articleNote.find((n) => n.item === i);
    if (myNote) {
      return (
        <>
          <br />
          {myNote.note ? (
            <span className="article-note">{myNote.note}</span>
          ) : null}
          {myNote.took ? (
            <span className="article-note"> Took Swatch</span>
          ) : null}
          {myNote.request ? (
            <span className="article-note"> Request Swatch</span>
          ) : null}
        </>
      );
    }
    return null;
  }

  // const handleEmail = () => {
  //   const who = store.who;
  //   const date = "March 20, 2023";
  //   const notes = "this is a note";
  //   const readable = store.articles;
  //   fetch("http://localhost:5001/mail/send", {
  //     method: "POST",
  //     body: JSON.stringify({
  //       readable,
  //       date,
  //       who,
  //       notes,
  //     }),
  //     headers: {
  //       "Content-type": "application/json; charset=UTF-8",
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data);
  //       //setPause(true);
  //       //setData([]);
  //       //setReadable([]);
  //       //setNotes("");
  //       // Handle data
  //     })
  //     .catch((err) => {
  //       console.log(err.message);
  //     });
  // };

  return (
    <div className="container">
      <div className="complete-content">
        <h1>{store.title}</h1>
        <h2>{store.who}</h2>
        <ul className="note-list">
          {store.articles.map((item, i) => (
            <li key={item}>
              {item} {store.articleNote.length && findArticleNote(i)}
            </li>
          ))}
        </ul>
        <hr />
        <div>{store.note ? store.note : "no notes"}</div>
      </div>
    </div>
  );
}

export default Complete;
